import { Component, computed, effect, HostBinding, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@abp/ng.core';
import { ErrorNotifierService, ERROR_MESSAGES } from '../../services';

@Component({
  selector: 'dw-core-error-notifier',
  standalone: true,
  imports: [CommonModule, CoreModule],
  templateUrl: './error-notifier.component.html',
  styleUrl: './error-notifier.component.css',
})
export class ErrorNotifierComponent {
  @Input() showErrors = false;
  @HostBinding('style.--appearance-delay') @Input() delay = 2000;
  showFromErrors = false;
  errorLength = computed(() => this.errors().filter(directive => directive.hasErrors).length);

  constructor(
    private errorNotifierService: ErrorNotifierService,
    @Inject(ERROR_MESSAGES)
    private errorMessages: {
      [key: string]: {
        errorMessage?: string;
        title?: string;
        notifierErrorMessage?: string;
      };
    },
  ) {
    effect(() => {
      let showFromErrors = this.errors().length > 0;
      if (showFromErrors && !this.showFromErrors) {
        this.showFromErrors = true;
        setTimeout(() => {
          this.showFromErrors = false;
        }, 0);
      }
    });
  }

  errors = computed(() => {
    const currentDirectives = this.errorNotifierService
      .contextualizedErrors()
      .filter(directive => directive.hasErrors);

    const errors = [];

    currentDirectives.forEach(directive => {
      Object.keys(directive.errors).forEach(errorKey => {
        const errorMessage = this.errorMessages[errorKey];
        if (errorMessage) {
          const errorValue = directive.errors[errorKey];
          const interpolationParams =
            errorValue && typeof errorValue === 'object'
              ? Object.values(errorValue).map(val => String(val))
              : [];

          errors.push({
            key: errorKey,
            title: errorMessage.title || '',
            errorMessage: errorMessage.errorMessage || '',
            notifierErrorMessage: errorMessage.notifierErrorMessage || '',
            directive,
            interpolationParams,
          });
        }
      });
    });

    return errors;
  });
}
